/**
 * @generated SignedSource<<391a70e042783351cdccc308aa2ad63d>>
 * @relayHash a7878f35d0b14c8c2dfc98bcba1d0174
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7c714d19ca75fb5fc540833a8ad029796dc92c353ccbc26de6a5a6e3f25cea61

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceAnalyticsAccountType = "AGENT" | "USER" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type usePageViewsAnalyticsViewersWithoutLimitQuery$variables = {
  contentId: string;
  engageTimeThreshold?: number | null;
  isAgentPrivacyMaskingEnabled?: boolean | null;
  isPrivacyModeEnabled?: boolean | null;
};
export type usePageViewsAnalyticsViewersWithoutLimitQuery$data = {
  readonly singleContent: {
    readonly contentAnalyticsViewsByUser: {
      readonly pageViews: ReadonlyArray<{
        readonly accountType: ConfluenceAnalyticsAccountType | null;
        readonly agentType: string | null;
        readonly confluenceUser: {
          readonly permissionType: SitePermissionType | null;
        } | null;
        readonly isEngaged: boolean | null;
        readonly isPrivate?: boolean | null;
        readonly lastVersionViewedNumber: number | null;
        readonly lastVersionViewedUrl: string | null;
        readonly lastViewedAt: string;
        readonly relatedUser: {
          readonly displayName: string | null;
          readonly id: string | null;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly relatedUserAccountId: string | null;
        readonly userId?: string;
        readonly userProfile: {
          readonly displayName: string | null;
          readonly id: string | null;
          readonly isActive: boolean | null;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly views: number;
      }>;
    } | null;
    readonly id: string | null;
    readonly subType: string | null;
    readonly version: {
      readonly number: number | null;
    } | null;
  } | null;
};
export type usePageViewsAnalyticsViewersWithoutLimitQuery = {
  response: usePageViewsAnalyticsViewersWithoutLimitQuery$data;
  variables: usePageViewsAnalyticsViewersWithoutLimitQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "engageTimeThreshold"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isAgentPrivacyMaskingEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isPrivacyModeEnabled"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "subType"
},
v7 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ]
},
v8 = [
  {
    "kind": "Variable",
    "name": "engageTimeThreshold",
    "variableName": "engageTimeThreshold"
  },
  {
    "kind": "Variable",
    "name": "isPrivacyModeEnabled",
    "variableName": "isPrivacyModeEnabled"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v10 = {
  "concreteType": "AtlassianUserPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "value"
    },
    {
      "kind": "ScalarField",
      "name": "isPrimary"
    }
  ]
},
v11 = {
  "concreteType": "ContentAnalyticsPageViewInfo",
  "kind": "LinkedField",
  "name": "pageViews",
  "plural": true,
  "selections": [
    {
      "condition": "isAgentPrivacyMaskingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "userId"
        },
        {
          "kind": "ScalarField",
          "name": "isPrivate"
        }
      ]
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isActive"
        }
      ]
    },
    {
      "concreteType": "ConfluenceUser",
      "kind": "LinkedField",
      "name": "confluenceUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "permissionType"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "accountType"
    },
    {
      "kind": "ScalarField",
      "name": "agentType"
    },
    {
      "kind": "ScalarField",
      "name": "relatedUserAccountId"
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "relatedUser",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v9/*: any*/),
        (v10/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "views"
    },
    {
      "kind": "ScalarField",
      "name": "lastViewedAt"
    },
    {
      "kind": "ScalarField",
      "name": "lastVersionViewedNumber"
    },
    {
      "kind": "ScalarField",
      "name": "lastVersionViewedUrl"
    },
    {
      "kind": "ScalarField",
      "name": "isEngaged"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "usePageViewsAnalyticsViewersWithoutLimitQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "args": (v8/*: any*/),
            "concreteType": "ContentAnalyticsViewsByUser",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewsByUser",
            "plural": false,
            "selections": [
              (v11/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "usePageViewsAnalyticsViewersWithoutLimitQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "args": (v8/*: any*/),
            "concreteType": "ContentAnalyticsViewsByUser",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewsByUser",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a7878f35d0b14c8c2dfc98bcba1d0174",
    "id": "7c714d19ca75fb5fc540833a8ad029796dc92c353ccbc26de6a5a6e3f25cea61",
    "metadata": {},
    "name": "usePageViewsAnalyticsViewersWithoutLimitQuery",
    "operationKind": "query",
    "text": "query usePageViewsAnalyticsViewersWithoutLimitQuery($contentId:ID!,$engageTimeThreshold:Int,$isPrivacyModeEnabled:Boolean,$isAgentPrivacyMaskingEnabled:Boolean=false){singleContent(id:$contentId){id,subType,version{number},contentAnalyticsViewsByUser(engageTimeThreshold:$engageTimeThreshold,isPrivacyModeEnabled:$isPrivacyModeEnabled){pageViews{userId@include(if:$isAgentPrivacyMaskingEnabled)\n        isPrivate@include(if:$isAgentPrivacyMaskingEnabled),userProfile{id,displayName,photos{value,isPrimary},isActive},confluenceUser{permissionType},accountType,agentType,relatedUserAccountId,relatedUser{id,displayName,photos{value,isPrimary}},views,lastViewedAt,lastVersionViewedNumber,lastVersionViewedUrl,isEngaged},id}}}"
  }
};
})();

(node as any).hash = "5ae20c5eebd7c3d5881fa9bf6dd410b1";

export default node;
